<footer class="layout-footer dt-footer">

    <div class="dt-footer-cols">

        <div class="dt-footer-col">
            <img class="dt-footer-logo" src="assets/layout/images/logo-doctorium-orizzontale.png" alt="Doctorium" />
            <p class="dt-footer-tagline">{{ 'Il tuo Dottore online. Consulti con specialisti e referti sempre nella tua area riservata.' | translate }}</p>
            <p class="dt-footer-data">
                <strong>Doctorium S.r.l.</strong><br>
                {{ 'P.IVA' | translate }}: 03504140793<br>
            </p>
        </div>

        <div class="dt-footer-col">
            <h2 class="dt-footer-heading">{{ 'Termini, condizioni e privacy' | translate }}</h2>
            <ul class="dt-footer-links">
                <li><a href="https://www.doctorium.it/condizioni-di-servizio-doctorium/" target="_blank">{{ 'Condizioni di Servizio Doctorium' | translate }}</a></li>
                <li><a href="https://www.doctorium.it/privacy-policy/" target="_blank">{{ 'Informativa Privacy' | translate }}</a></li>
                <li><a href="https://www.doctorium.it/informativa-e-consenso-informato/" target="_blank">{{ 'Informativa e consenso informato telemedicina' | translate }}</a></li>
                <li><a href="https://www.doctorium.it/cookie-policy/" target="_blank">Cookie Policy</a></li>
                <li><a href="/assets/doctorium_codice_autoregolamentazione_2026.pdf" target="_blank">{{ 'Codice di autoregolamentazione' | translate }}</a></li>
            </ul>
        </div>

        <div class="dt-footer-col">
            <h2 class="dt-footer-heading">{{ 'Seguici su' | translate }}</h2>
            <div class="dt-footer-social">
                <a target="_blank" href="https://www.facebook.com/doctoriummedicalinstitute" aria-label="Facebook"><i aria-hidden="true" class="pi pi-facebook"></i></a>
                <a target="_blank" href="https://www.instagram.com/doctorium_iltuodottoreonline/" aria-label="Instagram"><i aria-hidden="true" class="pi pi-instagram"></i></a>
                <a target="_blank" href="https://www.linkedin.com/company/64624592/" aria-label="LinkedIn"><i aria-hidden="true" class="pi pi-linkedin"></i></a>
                <a target="_blank" href="https://www.youtube.com/@doctorium7425/videos" aria-label="YouTube"><i aria-hidden="true" class="pi pi-youtube"></i></a>
            </div>
            <p class="dt-footer-help">
                {{ 'Hai bisogno di aiuto?' | translate }}
            </p>
            <!-- niente icone: "Scrivi a / Chiama il / Scrivici su" (scheda _1 pag. 29) -->
            <ul class="dt-footer-canali">
                <li>{{ 'Scrivi a' | translate }} <a href="mailto:info@doctorium.it">info&#64;doctorium.it</a></li>
                <li>{{ 'Chiama il' | translate }} <a href="tel:199290678">199 290 678</a></li>
                <li>{{ 'Scrivici su' | translate }} <a href="https://wa.me/393515278952" target="_blank" rel="noopener">WhatsApp</a></li>
            </ul>
        </div>

    </div>

    <div class="dt-footer-copyright">
        <span>&copy; {{ anno }} Doctorium S.r.l. &mdash; {{ 'Tutti i diritti riservati' | translate }}</span>
    </div>

</footer>
